export default __webpack_public_path__ + "static/future_cloud-5e392de4f66802c2201b4374c4c51716.webp";